import { Extension as r } from "../../node_modules/@tiptap/core/dist/index.mjs";
import { unsetTextStyleAttribute as o } from "../text-style-extension/utils/unset-text-style-attribute.mjs";
const i = r.create({
  name: "fontFamily",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontFamily: {
            default: null,
            parseHTML: (t) => {
              var e;
              return (e = t.style.fontFamily) == null ? void 0 : e.replace(/['"]+/g, "");
            },
            renderHTML: (t) => t.fontFamily ? {
              style: `font-family: ${t.fontFamily}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontFamily: (t) => ({ chain: e }) => e().setMark("textStyle", { fontFamily: t }).run(),
      unsetFontFamily: () => ({ tr: t, state: e, dispatch: n }) => o("fontFamily", e, t, n)
    };
  }
});
export {
  i as FontFamily
};
